import {
  Card,
  Heading,
  Link,
  ListItem,
  ListUnordered,
} from "@digdir/designsystemet-react";
import { ExternalLinkIcon } from "@navikt/aksel-icons";
import { Link as InternalLink } from "@tanstack/react-router";
import type { FileRoutesByTo } from "@/routeTree.gen";
import { cn } from "@/utils";

export type Lenke = {
  text: string;
  href: string;
  external?: boolean;
};

export type InternLenke = Omit<Lenke, "href"> & { href: keyof FileRoutesByTo };

type LenkerContainerProps = {
  links: Lenke[];
  title: string;
  className?: string;
  variant?: "default" | "tinted";
};

export function LenkerContainer({
  links,
  title,
  className,
  variant = "tinted",
}: LenkerContainerProps) {
  return (
    <Card className={cn("space-y-4 h-fit", className)} variant={variant}>
      <Heading level={3} data-size="xs">
        {title}
      </Heading>
      <ListUnordered className="list-none pl-0 space-y-4">
        {links.map((link) => (
          <ListItem key={link.href.toString()}>
            {link.external !== false ? (
              <Link
                href={link.href}
                target="_blank"
                rel="noreferrer"
                className="text-balder-text-default"
              >
                {link.text}
                <ExternalLinkIcon
                  fontSize={"1.5rem"}
                  className="pl-1"
                  aria-hidden
                />
              </Link>
            ) : (
              <Link asChild>
                <InternalLink to={link.href}>{link.text}</InternalLink>
              </Link>
            )}
          </ListItem>
        ))}
      </ListUnordered>
    </Card>
  );
}
